import { ApplicationState } from "../applicationState";

export const employeeUniqueIdSelector = (state: ApplicationState) => state.router.query?.employeeUniqueId;

export const emailAddressSelector = (state: ApplicationState) => state.router.query?.emailAddress;

export const phoneNumberSelector = (state: ApplicationState) => state.router.query?.phoneNumber;

export const dateOfBirthSelector = (state: ApplicationState) => state.router.query?.dateOfBirth;
